
function MOVE_PIECE({
    blindKingsGame: {
        turnNumber,
        turnIndex,
        turnsWithoutAction = 0,
        board,
        gameBoard,
        following,
        following: {
            [turnIndex]: {
                pieceId: prevFollowingPieceId,
                following: prevPieceFollowing = {},
            } = {},
        },
    },
    gamePiece,
    gamePiece: {
        id,
        value,
        teamIndex,
        location: {
            x: oldX,
            y: oldY,
        },
    },
    direction,
}) {

    const emptyPiece = gamePiece.getPieceToMoveToByDirection(direction);
    const {
        id: emptyPieceId,
        value: emptyPieceValue,
        teamIndex: emptyPieceTeamIndex,
        location: {
            x: newX,
            y: newY,
        },
    } = emptyPiece;

    const newBoard = board.map((row, boardY) => row.map((boardPiece, boardX) => {
        if ((boardX === oldX) && (boardY === oldY)) return {
            id: emptyPieceId,
            value: emptyPieceValue,
            teamIndex: emptyPieceTeamIndex,
        };
        if ((boardX === newX) && (boardY === newY)) return {
            id,
            value,
            teamIndex,
        };
        return boardPiece;
    }));

    const adjacentActivePieces = gameBoard.getAllActiveAdjacentPiecesByLocation(newY, newX);
    const adjacentOpponentPieces = adjacentActivePieces.filter(opponentPiece => opponentPiece.teamIndex !== teamIndex);

    const newFollowing = {
        ...following,
        [turnIndex]: {
            pieceId: id,
            following: adjacentOpponentPieces.reduce((all, { id: opponentPieceId, value: opponentValue }) => ({
                ...all,
                ...opponentValue < value && {
                    [opponentPieceId]: prevFollowingPieceId === id ?
                        (prevPieceFollowing[opponentPieceId] || 0) + 1
                        :
                        1,
                },
            }), {})
        }
    }

    return {
        board: newBoard,
        turnNumber: turnNumber + 1,
        turnsWithoutAction: turnsWithoutAction + 1,
        following: newFollowing,
    };
}

export default MOVE_PIECE;